import {
  CreditCardCodes,
} from '../constants';

const parseExp = (exp) => {
  if (!exp) return { month: undefined, year: undefined };
  // Match formats like "02/30", "02 / 2030", "02-2030", etc.
  const match = exp.trim().match(/^(\d{1,2})\s*[/\- ]\s*(\d{2,4})$/);
  if (!match) return { month: undefined, year: undefined };
  let [, month, year] = match;
  // Normalize month — pad single digit ("2" => "02")
  month = month.padStart(2, '0');
  // Normalize year — convert "2030" → "30", keep last 2 digits
  year = year.slice(-2);
  return { month, year };
};

const formatCreditCardPaymentRequest = (targetCard, card, isLoggedIn) => {
  const { month, year } = parseExp(targetCard.expiration);
  return ({
    cvc: targetCard.cvc || card.cvc,
    cardCode: targetCard.cardCode || CreditCardCodes[card.component],
    cardNumber: targetCard.cardNumber || card.cardNumber?.replace(/-/g, ''),
    cardExpMonth: (month) || (card.expiration ? card.expiration.match(/^\d{2}/)?.[0] : undefined),
    cardExpYear: (year) || (card.expiration ? card.expiration.match(/\d{2}$/)?.[0] : undefined),
    cardholderName: targetCard.cardHolderName?.trim() || card.cardHolderName?.trim(),
    billingAddress1: targetCard.addressLineOne || card.addressLineOne,
    billingAddress2: targetCard.addressLineTwo || card.addressLineTwo,
    billingCity: targetCard.city || card.city,
    billingStateProvCode: targetCard.state || card.state,
    billingZipCode: targetCard.billingCode || card.billingCode,
    billingCountryCode: targetCard.country || card.country,
    cardNumberLast4Chars: (targetCard.cardNumberLast4Chars) || (card.cardNumber ? card.cardNumber.match(/\d{4}$/)?.[0] : undefined),
    doSaveCard: isLoggedIn ? card.doSaveCard : undefined,
    doSetAsDefault: isLoggedIn ? card.doSetAsDefault : undefined,
    informationText: isLoggedIn && card.doSaveCard ? card.informationText : undefined,
    selectedFor: card.selectedFor,
  });
};
export default formatCreditCardPaymentRequest;
